import React, {useEffect } from 'react'; 
import Header from "../Component/Header";
import { Link } from 'react-router-dom'
const BusRoutes = () => {
    useEffect(() => {
        document.title = 'Bus Routes -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li> Admissions </li>
                 <li>Bus Routes</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Bus Routes </h1>
                    </div>
                </div>
                <div className="row">
                <div className="col-xl-4 col-lg-6 col-md-6">
                        <div className="linktab"> <Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/SCHOOL BUS ROUTES.pdf" target="_blank"> Click here to view - SCHOOL BUS ROUTES
                        </Link> </div>
                </div>
                <div className="col-xl-4 col-lg-6 col-md-6">
                       <div className="linktab"> <Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/UNDERTAKING.pdf" target="_blank"> Click here to download - UNDERTAKING </Link> </div>
                    </div>
                    <div className="col-xl-4 col-lg-6 col-md-6">
                       <div className="linktab"> <Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/SCHOOL BUS FORM.pdf" target="_blank"> Click here to download - SCHOOL BUS FORM </Link> </div>
                    </div>
                    <div className="col-xl-4 col-lg-6 col-md-6">
                    <div className="linktab"> <Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/INDEMNITY BOND.pdf" target="_blank"> Click here to download - INDEMNITY BOND </Link> </div>
                 </div>
            </div>
            </div>
        </div>
     </>
  )
}

export default BusRoutes